/**
 * /* eslint-disable no-unused-vars
 *
 * @format
 */

/** @format */

import { TextField } from "@mui/material";
import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Row } from "react-bootstrap";
import Col from "react-bootstrap/cjs/Col";

import { Formik, Form, Field } from "formik";
import qs from "qs";

// import { FaAngleDown } from "react-icons/fa";
import DialogContentText from "@mui/material/DialogContentText";
// import { components } from "react-select";
import CustomSelectAsync from "src/components/CustomSelectAsync";
// import Waba from "../../dao/Waba";
import Cost from "../../dao/Cost";
import swal from "../../reusables/CustomSwal";
// import useGetPhoneNumberByWABA from "../../hooks/useGetPhoneNumberByWABA";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
export default function CreateOTPManagementDialog(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { open, onClose } = props;
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  let idParam = queryParams.waba_id;
  // const { data: dataPhoneNumber, isLoading: isLoadingPhoneNumber } =
  //   useGetPhoneNumberByWABA(idParam);

  const [initData, setInitData] = useState({
    otp_name: "",
    message_template: "",
    duration_expired: "",
    total_length_code: 0,
  });

  React.useEffect(() => {
    setInitData({ ...initData, waba_id: idParam });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idParam]);

  const onSubmit = async (values) => {
    try {
      swal
        .fire({
          title: "",
          text: "Are you sure you want to create this item?",
          icon: "warning",
          showCancelButton: true,
          confirmButton: "Yes",
          confirmButtonColor: "#3085d6",
          cancelButton: "Cancel",
          // cancelButtonColor: '#d33',
        })
        .then(async (result) => {
          try {
            if (result.isConfirmed) {
              let res = await Cost.addCost(values);
              if (res.id || res.success) {
                await swal.fire({
                  title: "",
                  text: "Creation Successful",
                  icon: "success",
                });
              }
              handleClose(true);
            } else {
              await swal.fire({
                title: "",
                text: "Creation Failed",
                icon: "error",
              });
            }
          } catch (e) {
            console.error(e);
            await swal.fire({
              title: "",
              text: "Phone Number has been used",
              icon: "error",
            });
          }
          await navigate(0);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const reset = () => {
    // setWabaId(null);
  };

  const handleClose = (refresh) => {
    reset();
    onClose(refresh);
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={() => onClose()}
      >
        <Formik
          enableReinitialize
          // validationSchema={FormSubmission1Schema}
          initialValues={initData}
          onSubmit={(values) => {
            onSubmit(values);
          }}
        >
          {(props) => {
            const { values, handleChange } = props;
            return (
              <Form>
                <DialogTitle>Create OTP</DialogTitle>
                <DialogContent
                  sx={{ paddingBottom: "60px", paddingTop: "60px" }}
                >
                  <Row>
                    <Col md={12}>
                      <DialogContentText>OTP Name</DialogContentText>
                      <TextField
                        name="waba_id"
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        value={values.otp_name}
                        onChange={handleChange}
                        fullWidth
                        placeholder={"OTP Name"}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <DialogContentText>
                        Choose Message Template
                      </DialogContentText>
                      <Field
                        className="custom-select"
                        name="message_template"
                        data={[]}
                        isLoading={false}
                        component={CustomSelectAsync}
                        placeholder="Choose message template"
                        isMulti={false}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <DialogContentText>Set Duration Expired</DialogContentText>
                    <Field
                      className="custom-select"
                      name="duration_expired"
                      data={[]}
                      isLoading={false}
                      component={CustomSelectAsync}
                      placeholder="Set Duration Expired"
                      isMulti={false}
                    />
                  </Row>

                  <Row>
                    <Col md={12}>
                      <DialogContentText>
                        Set Total Length Code
                      </DialogContentText>
                      <Field
                        className="custom-select"
                        name="total_length_code"
                        data={[]}
                        isLoading={false}
                        component={CustomSelectAsync}
                        placeholder="Total Length Code"
                        isMulti={false}
                      />
                    </Col>
                  </Row>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button type="submit">Add</Button>
                </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </Dialog>
    </>
  );
}
